import { Controller } from "stimulus"

export default class extends Controller {
    static values = {
        product: String,
        toastMessage: String,
        toastState: String
    }

    like_product(event) {
        if (event && typeof event.preventDefault === "function") {
            event.preventDefault();
        }

        const productId = this.productValue
        if (!productId) {
            console.warn("like_product: missing product id")
            return
        }

        const requestUrl = this.data.get("update-url")
        if (!requestUrl) {
            console.warn("like_product: missing update url")
            return
        }

        const formData = new FormData()
        formData.append("product_id", productId)

        fetch(requestUrl, {
            method: "POST",
            credentials: "include",
            dataType: "script",
            headers: {
                "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content
            },
            body: formData
        })
            .then(response => response.text())
            .then(html => {
                const target = document.getElementById("liked_products")
                if (target) {
                    target.innerHTML = html
                }
                this.showToast()
            })
            .catch(err => console.log("Can’t access response. Blocked by browser?" + err))
    }

    remove_like_product(event) {
        if (event && typeof event.preventDefault === "function") {
            event.preventDefault()
        }

        fetch(this.data.get("update-url"), {
            method: "DELETE",
            credentials: "include",
            dataType: "script",
            headers: {
                "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content
            }
        })
            .then(response => response.text())
            .then(html => {
                const target = document.getElementById("liked_products")
                if (target) {
                    target.innerHTML = html
                }
            })
            .catch(err => console.log("Can’t access response. Blocked by browser?" + err))
    }

    showToast() {
        if (!this.hasToastMessageValue) {
            return
        }

        const container = document.getElementById("like-toast-container")
        if (!container) {
            return
        }

        const state = this.hasToastStateValue ? this.toastStateValue : "pending"
        const iconClass = state === "assured" ? "fas fa-check-circle" : "fas fa-shipping-fast"

        const toast = document.createElement("div")
        toast.className = `like-toast like-toast--${state}`
        toast.innerHTML = `
            <span class="like-toast__icon"><i class="${iconClass}"></i></span>
            <span>${this.toastMessageValue}</span>
        `

        container.appendChild(toast)

        // Trigger animation frame to enable transition
        requestAnimationFrame(() => {
            toast.classList.add("show")
        })

        setTimeout(() => {
            toast.classList.remove("show")
            setTimeout(() => {
                toast.remove()
            }, 200)
        }, 4000)
    }
}
